import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { MiMenu } from "@miplatform/components";
import { BUTTON_LABELS } from "@miplatform/constants";
import { ITenantHolidayResponse } from "@miplatform/types";
import { formatDate } from "@miplatform/utils";
import { mdiPencilOutline, mdiTrashCanOutline } from "@mdi/js";
import { Box, Typography } from "@mui/material";

export const ConfigHolidayListCard: FC<IConfigHolidayListCardProps> = ({
  item: holiday,
  onEdit = () => {},
  onDelete,
}) => {
  const { classes, theme } = useStyles();
  const { name, startDate, endDate, createdOn } = holiday;

  const handleClick = () => {
    onEdit(holiday);
  };

  const actions = [
    {
      label: BUTTON_LABELS.EDIT,
      action: handleClick,
      icon: mdiPencilOutline,
    },
  ];

  if (onDelete) {
    actions.push({
      label: BUTTON_LABELS.DELETE,
      action: () => onDelete(holiday),
      icon: mdiTrashCanOutline,
    });
  }

  return (
    <Box className={classes.card} onClick={handleClick}>
      <Box className={classes.nameColumn}>
        <Typography variant="HD2" color={theme.palette.primary.main}>
          {name}
        </Typography>
        <Typography
          variant="HD1"
          fontWeight={400}
          color={theme.palette.text.secondary}
        >
          Created: {formatDate(createdOn, "MMMM DD, YYYY")}
        </Typography>
      </Box>
      <Box className={classes.dateColumn}>
        <Typography variant="HD1" color={theme.palette.text.secondary}>
          Start Date
        </Typography>
        <Typography variant="HD1" fontWeight={400}>
          {formatDate(startDate, "MMMM DD, YYYY")}
        </Typography>
      </Box>
      <Box className={classes.dateColumn}>
        <Typography variant="HD1" color={theme.palette.text.secondary}>
          End Date
        </Typography>
        <Typography variant="HD1" fontWeight={400}>
          {formatDate(endDate, "MMMM DD, YYYY")}
        </Typography>
      </Box>
      <Box onClick={(e) => e.stopPropagation()}>
        <MiMenu data={actions} />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  card: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.12)",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.grey.light,
    },
  },
  nameColumn: {
    flex: 2,
    display: "flex",
    flexDirection: "column" as const,
    gap: theme.spacing(0.5),
  },
  dateColumn: {
    flex: 1.5,
    display: "flex",
    flexDirection: "column" as const,
    gap: theme.spacing(0.5),
  },
}));

interface IConfigHolidayListCardProps {
  item: ITenantHolidayResponse;
  onEdit: (holiday: ITenantHolidayResponse) => void;
  onDelete?: (holiday: ITenantHolidayResponse) => void;
}
